import * as React from 'react';
import { useContext } from 'react';
import { CartContext } from '../Cart';

import CartServiceSummary from '../../ServiceSummary';
import { useTranslation } from 'react-i18next';
import { CartServiceProps } from '../types';
import { ServiceSummary } from '../../features/service-summary';
import { ServiceSummaryType } from '../../ServiceSummary/types';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { CdnIcon } from '@shared/ui';

const Meals: React.FC<CartServiceProps> = ({ onServiceDelete, renderService, activeStep, steps }) => {
	const cartConfig = useContext(CartContext);

	const { t } = useTranslation('Cart');

	const group: ServiceSummaryType = {
		header: t('Meal'),
		icon: <CdnIcon icon={'Services/Meal'} />,
		totalPrice: cartConfig.totalPrices?.meal,
		disabled: activeStep < steps?.findIndex(step => step.type === CheckoutSteps.Meal) || false
	};

	return (
		<ServiceSummary serviceType="Meal" onDelete={onServiceDelete}>
			{content =>
				renderService?.(CheckoutSteps.Meal, group, content) ?? (
					<CartServiceSummary group={group}>{content}</CartServiceSummary>
				)
			}
		</ServiceSummary>
	);
};

export default Meals;
